import "./BrowserSupportPopup.scss";
import React from "react";
import { FormattedMessage } from "react-intl";
import { detect } from "detect-browser";
import browserRules from "../../../min-browser-versions.json";

function BrowserSupportPopup() {
	const isBrowserSupported = () => {
		const { name, version } = detect() ?? {};
		const minVersion = browserRules[name ?? "unknown"];

		if (!name || !version || !minVersion) {
			return true;
		}

		if (minVersion === "NONE") {
			return false;
		}

		const versionParts = version.split(".").map(part => parseInt(part, 10));
		const minVersionParts = minVersion.split(".").map(part => parseInt(part, 10));
		return minVersionParts.reduce((acc, minVersionPart, i) => acc && versionParts[i] >= minVersionPart, true);
	};

	if (isBrowserSupported()) {
		return null;
	}

	return (
		<div className="mfcss_bottom-notification">
			<div className="mfcss_bottom-notification-text">
				<FormattedMessage id="BROWSER_NOT_SUPPORTED" />
			</div>
		</div>
	);
}

export default BrowserSupportPopup;
